import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { DestinationEditor } from "@/components/admin/DestinationEditor";
import { adminGetDestination } from "@/lib/destinations.functions";
import { RouteErrorBoundary } from "@/lib/route-boundaries";

export const Route = createFileRoute("/admin/destinations/$id")({
  head: () => ({
    meta: [
      { title: "Editar destino | Admin | Fora da Rota" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EditDestination,
  errorComponent: RouteErrorBoundary,
});

function EditDestination() {
  const { id } = Route.useParams();
  const get = useServerFn(adminGetDestination);
  const q = useQuery({
    queryKey: ["admin", "destination", id],
    queryFn: () => get({ data: { id } }),
  });
  if (q.isLoading) return <div className="p-6 text-muted-foreground">Cargando…</div>;
  if (!q.data) return <div className="p-6">No encontrado.</div>;
  return <DestinationEditor initial={q.data} />;
}
